import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute , Router, Params } from '@angular/router';

import { AuthManagerService, LogInResponse } from '../../../shared/services/auth-manager.service';

class LoginErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted: boolean = form && form.submitted;
    return (control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'core-manual-login',
  templateUrl: './manual-login.component.html',
  styleUrls: ['./manual-login.component.scss']
})
export class ManualLoginComponent implements OnInit {

  //Form Controls
  public userNameFormControl: UntypedFormControl = new UntypedFormControl('', [
    Validators.required
  ]);
  public passwordFormControl: UntypedFormControl = new UntypedFormControl('', [
    Validators.required
  ]);

  //Form
  public loginForm: UntypedFormGroup = new UntypedFormGroup({
    'userName': this.userNameFormControl,
    'password': this.passwordFormControl
  });

  //Variables
  private matcher: LoginErrorStateMatcher = new LoginErrorStateMatcher();
  public loading: boolean = false;
  public errorMessage: string = '';
  private returnUrl: string = '';

  constructor(
    private authManager: AuthManagerService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
    });
  }

  public logIn() {
    this.loading = true;
    this.authManager.logIn(this.userNameFormControl.value, this.passwordFormControl.value)
      .subscribe((response: LogInResponse) => {
        this.loading = false;

        if (response.successful) {
          if (this.returnUrl) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.router.navigateByUrl('/');
          }
        } else {
          this.errorMessage = response.message;
        }
      });
  }
}
